<template>
  <div id="loaderping" v-show="loaderVisble" v-bind:style="styles" class="spinnerP spinner--ping-pong">
    <div v-bind:style="innerStyles" class="spinner-inner">
      <div class="board">
        <div class="left">
        </div>
        <div class="right">
        </div>
        <div class="ball">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  inheritAttrs: true,
  name: 'PingPong',
  data () {
    return {
      size: '40px',
      loaderVisble: false
    }
  },
  methods: {
    setloader (bool) {
      this.loaderVisble = bool
      return this.loaderVisble
    },
    isLoderVisible () {
      if (this.loaderVisble) {
        return true
      } else {
        return false
      }
    },
    displayLoader () {
      this.setloader(true)
    },
    hideloader () {
      this.setloader(false)
    }
  },
  watch: {
    //
  },
  render: (createElement) => {
    return createElement(Vue.component(this))
  },
  created: function () {
    //
  },
  computed: {
    loaderVisbleRender: {
      get: function () {
        // alert("Assembling full name...")
        return true
      },
      set: function (params) {
        // alert("Setting new name: " + params);
        this.loaderVisble = false
      }
    },
    innerStyles () {
      let size = parseInt(this.size)
      return {
        transform: 'scale(' + (size / 250) + ')'
      }
    },
    styles () {
      var style = document.documentElement.style
      style.setProperty('--width', this.size)
      style.setProperty('--height', this.size)
      return {
        width: this.size,
        height: this.size
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.spinnerP {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  * {
    line-height: 0;
    box-sizing: border-box;
    position: relative;
    z-index: 99999;
  }
}
.spinnerP {
  margin: 0 auto;
  width: 70px;
  height: 180px;
  text-align: center;
  position: absolute;
  left: calc(50% - (var(--width) / 2));
  right: auto;
  top: calc(50% - (var(--height)));
  bottom: 50%;
  z-index: 9999;
}

.spinnerP::after {
  position: fixed;
  height: 200vh;
  width: 200vw;
  /* left: -100%; */
  right: 0;
  top: 0;
  content: ' ';
  display: block;
  background: rgba(0, 0, 0, 0.7);
  pointer-events: none;
  z-index: 9998;
}
.board {
  width: 250px;
  position: relative;
}

.left,
.right {
  height: 50px;
  width: 15px;
  background: #fff;
  display: inline-block;
  position: absolute;
}

.left {
  left: 0;
  animation: pingpong-position1 2s linear infinite;
}
.right {
  right: 0;
  animation: pingpong-position2 2s linear infinite;
}
.ball {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #41b883;
  position: absolute;
  animation: pingpong-bounce 2s linear infinite;
}
@keyframes pingpong-position1 {
  0% {
    top: -60px;
  }
  25% {
    top: 0;
  }
  50% {
    top: 60px;
  }
  75% {
    top: -60px;
  }
  100% {
    top: -60px;
  }
}
@keyframes pingpong-position2 {
  0% {
    top: 60px;
  }
  25% {
    top: 0;
  }
  50% {
    top: -60px;
  }
  75% {
    top: -60px;
  }
  100% {
    top: 60px;
  }
}
@keyframes pingpong-bounce {
  0% {
    top: -35px;
    left: 10px;
  }
  25% {
    top: 25px;
    left: 225px;
  }
  50% {
    top: 75px;
    left: 10px;
  }
  75% {
    top: -35px;
    left: 225px;
  }
  100% {
    top: -35px;
    left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// pingpongloader.vue?2a84f9d7